"use strict";

import angular from "angular";

angular.module("nucont.accounting.integrations", ["nucont.shared"]);
require("./integrations.routes");
